import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Tracking from './Tracking';

const RouteManager = ({ title, component: Component, eventName = '', isPrivate, allowMvpd, isSheerId }) => {
  const { isAuthenticated, hasMvpd } = useSelector((s) => s.user);
  const { routes } = useSelector((s) => s.appConfig);
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);
  const isSheerVerification = location.pathname.includes(routes.sheerIdVerification);
  const params = useParams();

  if (isSheerId && isPrivate && !isAuthenticated) {
    let redirectRoute = hasMvpd ? routes.myAccount : routes.signupCreateAccount;
    const sheerType = urlParams.get('sheerVerification');
    redirectRoute =
      isSheerVerification && sheerType ? `${redirectRoute}?sheerVerification=${sheerType}` : redirectRoute;
    return <Navigate to={redirectRoute} state={{ from: location }} replace />;
  }

  if (isPrivate && !isAuthenticated && !(allowMvpd && hasMvpd)) {
    const redirectRoute = hasMvpd ? routes.myAccount : routes.signin;
    return <Navigate to={redirectRoute} state={{ from: location }} replace />;
  }

  return (
    <Tracking title={title} location={location} eventName={eventName}>
      <Component location={location} params={params} />
    </Tracking>
  );
};

export default RouteManager;
